module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 05 Farma Pasa - Gorile (gost. Eli Maca).1d49138a.mp3";